import React, {Component} from 'react';
import {authService} from "../../../auth";
import OtherExperiencePopUp from "./OtherExperiencePopUp";
import OtherJobAndAssignmentPopUp from "./OtherJobAndAssignmentPopUp";
import OtherEventsPopUp from "./OtherEventsPopUp";
import OtherTrainingPopUp from "./OtherTrainingPopUp";
import OtherExperienceAndTrainingAllPopUp from "./OtherExperienceAndTrainingAllPopUp";
import OtherExpeditionsPopUp from "./OtherExpeditionsPopUp";
import OtherStoryBooksPopUp from "./OtherStoryBooksPopUp";
import OtherFundRaisesPopUp from "./OtherFundRaisesPopUp";
import HorizontalScroll from 'react-scroll-horizontal';
import {isMobileDevice} from "./../../../commons/CommonFunctions";
if (isMobileDevice()) {
    import('./../../../commons/styles/responsive-useragent.css').then(() => {
       console.log("Imported mobile css");
    });
}

class OtherExperienceTrainingEventsPopUp extends Component {

    constructor(props) { 
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            allShow:false,
            onlyExperienceShow:true,
        }
    }


    setAllLength = (length) => {
        this.setState({ 'allLength': length });
        if(length>0){
            this.setState({allShow:true,onlyExperienceShow:false});
        }
    }


    render() {
        const parent  = { height: '40px'}
        return (
            <div id="profExperiencepop" className="modal fade dgpopup reqendorse">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="profsectiondesc">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>
                                <div className="topbar">
                                    <HorizontalScroll className="horizontalNav" style={parent} reverseScroll>
                                        <ul id="tabs" className="nav">

                                            {this.props.experienceLength > 0 ?
                                                <li className="nav-item"><a href="javascript:void(0)"
                                                                            data-target="#other-prof-all-pop"
                                                                            data-toggle="tab"
                                                                            className="nav-link active">Experience</a>
                                                </li> : null
                                            }

                                            {/* {this.props.allLength > 0 ?
                                                <li className="nav-item"><a href="javascript:void(0)"
                                                                            data-target="#other-prof-all-pop"
                                                                            data-toggle="tab"
                                                                            className="nav-link active">Experience</a>
                                                </li> : null
                                            } */}
                                            
                                            {/* {this.props.experienceLength > 0 ? <li className="nav-item"><a href="javascript:void(0)"
                                                                        data-target="#other-prof-expierence-pop"
                                                                        data-toggle="tab"
                                                                        className="nav-link active">Job</a>
                                            </li> : null} */}

                                            {/* {this.props.allLength === 0 ?
                                    <li className="nav-item"><a href="javascript:void(0)"
                                                                data-target="#other-prof-expierence-pop"
                                                                data-toggle="tab"
                                                                className="nav-link active">Job</a>
                                    </li> : this.props.experienceLength>0?
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-expierence-pop"
                                                                    data-toggle="tab"
                                                                    className="nav-link">Job</a>
                                        </li>:null
                                }
                                            {this.props.jobAndAssignmentLength > 0 &&
                                            <li className="nav-item"><a href="javascript:void(0)"
                                                                        data-target="#other-prof-rrojects-pop"
                                                                        data-toggle="tab"
                                                                        className="nav-link">Assignment</a>
                                            </li>}
                                            {this.props.trainingLength > 0 ?
                                                <li className="nav-item"><a href="javascript:void(0)"
                                                                            data-target="#other-prof-training-pop"
                                                                            data-toggle="tab"
                                                                            className="nav-link">Training</a>
                                                </li> : null
                                            }
                                            {this.props.eventLength > 0 ?
                                                <li className="nav-item"><a href="javascript:void(0)"
                                                                            data-target="#other-prof-events-pop"
                                                                            data-toggle="tab"
                                                                            className="nav-link">Events</a>
                                                </li> : null
                                            }
                                            {this.props.expeditionLength > 0 ?
                                                <li className="nav-item"><a href="javascript:void(0)"
                                                                            data-target="#other-prof-expeditions-pop"
                                                                            data-toggle="tab"
                                                                            className="nav-link">Expeditions</a>
                                                </li> : null
                                            }
                                            {this.props.storyBookLength > 0 ?
                                                <li className="nav-item"><a href="javascript:void(0)"
                                                                            data-target="#other-prof-storybooks-pop"
                                                                            data-toggle="tab"
                                                                            className="nav-link">Storybook</a>
                                                </li> : null
                                            }
                                            {this.props.fundRaiseLength > 0 ?
                                                <li className="nav-item"><a href="javascript:void(0)"
                                                                            data-target="#other-prof-fundraises-pop"
                                                                            data-toggle="tab"
                                                                            className="nav-link">Fund Raise</a>
                                                </li> : null
                                            } */}

                                        </ul>
                                    </HorizontalScroll>
                                </div>
                                <div id="tabsContent" className="tab-content"> 
                                    <OtherExperiencePopUp personalExperience={this.props.personalExperience} userId={this.props.userId} isShow={this.state.onlyExperienceShow}/>
                                    {/* <OtherJobAndAssignmentPopUp userId={this.props.userId}/> */}
                                    {/* <OtherEventsPopUp userId={this.props.userId}/> */}
                                    {/* <OtherTrainingPopUp userId={this.props.userId}/> */}
                                    {/* <OtherExpeditionsPopUp userId={this.props.userId}/> */}
                                    {/* <OtherStoryBooksPopUp userId={this.props.userId}/> */}
                                    {/* <OtherFundRaisesPopUp userId={this.props.userId}/> */}
                                    {/* <OtherExperienceAndTrainingAllPopUp userId={this.props.userId} isShow={this.state.allShow} setAllLength={this.setAllLength}/> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default OtherExperienceTrainingEventsPopUp;
